module.exports = __webpack_public_path__ + "media/images/reservation_check_markreservation_triangle_mark-ecaa1932d67108ceea69600fb2be2146.svg";